<template>
  <p>Check Authentication .....</p>
</template>

<script>
import config from "@/appConfig";
export default {
  mounted() {
    const qs = window.location.search.substring(1).split("&");
    const params = {};
    for (let i = 0; i < qs.length; i++) {
      const a = qs[i].split("=");
      params[a[0]] = a[1];
    }
    if (params["code"] != undefined) {
      this.loadingOverlay = true;
      this.$store
        .dispatch("auth/loginSso", {
          code: params["code"],
          redirectUrl:
            window.location.protocol +
            "//" +
            window.location.host +
            process.env.VUE_APP_PUBLIC_PATH +
            "/login",
        })
        .then(() => {
          this.loadingOverlay = false;
          if (this.$store.getters["auth/isAuthenticated"]) {
            this.$router.push("/forbidden");
          }
        });
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    loginSso: function() {
      const authServerUrl = "https://sso.bps.go.id/auth";
      const realm = "pegawai-bps";
      const clientId = config.SSO_CLIENT_ID;
      const redirectUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        process.env.VUE_APP_PUBLIC_PATH +
        "/login";
      const state = "abcdefghij";
      const url =
        authServerUrl +
        "/realms/" +
        realm +
        "/protocol/openid-connect/auth?" +
        "scope=name,email" +
        "&response_type=code" +
        "&client_id=" +
        clientId +
        "&redirect_uri=" +
        redirectUrl +
        "&state=" +
        state;
      window.location.replace(url);
    },
  },
};
</script>
